export const DEBOUNCE_DELAY_MS = 300;
